var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgViviendasRed = function SvgViviendasRed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 33,
    fill: "none",
    viewBox: "0 0 48 33"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "viviendas-red_svg__Capa_1",
    clipPath: "url(#viviendas-red_svg__clip0_295_845)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "viviendas-red_svg__Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "viviendas-red_svg__Vector",
    fill: "#510C76",
    d: "M36.723 21.332h6.243v9.788c0 .85-.692 1.54-1.543 1.54h-4.694V21.326z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "viviendas-red_svg__Group_2",
    fill: "#FF1B51"
  }, /*#__PURE__*/React.createElement("path", {
    id: "viviendas-red_svg__Vector_2",
    d: "m38.648 2.372-4.84 8.37c-.535.92.134 2.074 1.196 2.074h9.681a1.382 1.382 0 0 0 1.197-2.074l-4.84-8.37c-.534-.92-1.866-.92-2.394 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "viviendas-red_svg__Vector_3",
    d: "m38.812 8.112-6.964 12.043c-.458.79.117 1.78 1.032 1.78h13.93c.914 0 1.49-.99 1.032-1.78L40.877 8.112a1.19 1.19 0 0 0-2.059 0z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "viviendas-red_svg__Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "viviendas-red_svg__Vector_4",
    fill: "#510C76",
    d: "m20.518 0 14.44 10.315h3.725c1.215 0 1.713-1.552.728-2.261L28.134 0z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "viviendas-red_svg__Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "viviendas-red_svg__Vector_5",
    fill: "white",
    d: "M37.18 10.303H8.303v22.703h28.879z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "viviendas-red_svg__Vector_6",
    fill: "white",
    d: "M22.742 0 8.302 10.315h28.879z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "viviendas-red_svg__Vector_7",
    fill: "#510C76",
    d: "M28.861 18.69h-6.788c-.58 0-1.05.47-1.05 1.05v12.112c0 .579.47 1.048 1.05 1.048h6.788c.58 0 1.05-.469 1.05-1.048V19.739c0-.579-.47-1.048-1.05-1.048"
  })), /*#__PURE__*/React.createElement("path", {
    id: "viviendas-red_svg__Vector_8",
    fill: "#510C76",
    d: "M1.443 10.203H12.71v21.69A1.11 1.11 0 0 1 11.599 33H2.553a1.11 1.11 0 0 1-1.109-1.107z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "viviendas-red_svg__Vector_9",
    fill: "#FF1B51",
    d: "M14.598 9.618 28.063 0h-13.67c-.78 0-1.538.246-2.171.697L.247 9.249c-.464.334-.23 1.066.34 1.066h11.84c.78 0 1.537-.246 2.171-.697"
  })), /*#__PURE__*/React.createElement("path", {
    id: "viviendas-red_svg__Vector_10",
    fill: "#FF1B51",
    d: "M27.887 25.24a.844.844 0 1 0 .001-1.69.844.844 0 0 0-.001 1.69"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "viviendas-red_svg__clip0_295_845"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M0 0h48v33H0z"
  })))));
};
export default SvgViviendasRed;